import * as React from "react";
import { DateTime } from "luxon";
import { TimePrecision } from "@focus/focusUI";
import UTCDatePicker from "./UTCDatePicker";
import UTCDateTimePicker from "./UTCDateTimePicker";
import { DATE_FORMATS } from "../interfaces";
import { EpochTextInput } from "./EpochTextInput";
import { Classes } from "@focus/focusUI";
export const EpochText = ({ dateTime, format, onChange, isDisabled, isReadOnly, isHidden, schemaDefaultDateTime, }) => {
    const onAbsoluteDateChange = (newValue) => {
        onChange(newValue);
    };
    const onRelativeDateChange = (newValue) => {
        let yearMonth = formData.substring(0, formData.indexOf("/") + 4);
        const newDateTime = yearMonth + newValue;
        onChange(newDateTime);
    };
    const onPickerDateChange = (pattern) => (dateUTC) => {
        let newDateTime = dateUTC
            .toString()
            .slice(0, -1)
            .replace(/-/g, "/")
            .replace("T", "-");
        if (newDateTime.length < pattern.length) {
            do {
                newDateTime += "0";
            } while (newDateTime.length < pattern.length);
        }
        else if (newDateTime.length > pattern.length) {
            newDateTime = newDateTime.slice(0, pattern.length - newDateTime.length);
        }
        onChange(newDateTime);
    };
    const getDateFromData = (formData, pattern) => {
        let newDateTime = DateTime.fromFormat("2020/01/01", "yyyy/MM/dd");
        let newPattern = pattern.slice();
        let newFormData = formData.slice();
        if (newPattern.length == "yyyy/MM/dd-HH:mm:ss.SSS000".length) {
            newPattern = newPattern.slice(0, -3);
        }
        if (newFormData.length == "yyyy/MM/dd-HH:mm:ss.SSS000".length) {
            newFormData = newFormData.slice(0, -3);
        }
        if (typeof formData !== "undefined" && formData !== null) {
            const auxDate = DateTime.fromFormat(newFormData, newPattern);
            if (auxDate.isValid) {
                newDateTime = auxDate;
            }
        }
        return newDateTime;
    };
    const getDate = (dateTime, defaultDateTime) => {
        let date;
        if (dateTime) {
            date = dateTime;
        }
        else if (defaultDateTime) {
            date = defaultDateTime;
        }
        else {
            date = "";
        }
        return date;
    };
    const getDateValue = (defaultDate, isRelative) => {
        let dateValue = defaultDate;
        if (typeof formData !== "undefined") {
            value = isRelative
                ? formData.substring(formData.indexOf("/") + 4)
                : formData;
            if (value.length < dateValue.length) {
                value = value + dateValue.substring(value.length);
            }
            dateValue = value;
        }
        return dateValue;
    };
    let field;
    let classNames;
    let value = "";
    let dateValue = "";
    let pattern = "";
    let newDate = null;
    let changeFunc = onAbsoluteDateChange;
    let formData = getDate(dateTime, schemaDefaultDateTime);
    let popoverContent = null;
    switch (format) {
        case DATE_FORMATS.DAY_ABS:
            classNames = "epoch-absolute-div";
            dateValue = getDateValue("____/__/__", false);
            pattern = "yyyy/MM/dd";
            newDate = getDateFromData(formData, pattern);
            popoverContent = (React.createElement(UTCDatePicker, { onChange: onPickerDateChange(pattern), value: newDate, key: "DatePicker" }));
            break;
        case DATE_FORMATS.DAY_REL:
            classNames = Classes.INPUT;
            dateValue = getDateValue("__", true);
            pattern = "00";
            changeFunc = onRelativeDateChange;
            break;
        case DATE_FORMATS.MIC_ABS:
            classNames = "epoch-absolute-div";
            dateValue = getDateValue("____/__/__-__:__:__.______", false);
            pattern = "yyyy/MM/dd-HH:mm:ss.SSS000";
            newDate = getDateFromData(formData, pattern);
            popoverContent = (React.createElement(UTCDateTimePicker, { onChange: onPickerDateChange(pattern), value: newDate, precision: TimePrecision.MILLISECOND, key: "DatePicker" }));
            break;
        case DATE_FORMATS.MIC_REL:
            classNames = Classes.INPUT;
            dateValue = getDateValue("__-__:__:__.______", true);
            pattern = "00-HH:mm:00.000000";
            changeFunc = onRelativeDateChange;
            break;
        case DATE_FORMATS.SEC_ABS:
            classNames = "epoch-absolute-div";
            dateValue = getDateValue("____/__/__-__:__:__", false);
            pattern = "yyyy/MM/dd-HH:mm:ss";
            newDate = getDateFromData(formData, pattern);
            popoverContent = (React.createElement(UTCDateTimePicker, { onChange: onPickerDateChange(pattern), value: newDate, precision: TimePrecision.SECOND, key: "DatePicker" }));
            break;
        case DATE_FORMATS.SEC_ABS_DOT:
            classNames = "epoch-absolute-div";
            dateValue = getDateValue("____/__/__-__:__:__.", false);
            pattern = "yyyy/MM/dd-HH:mm:ss.";
            newDate = getDateFromData(formData, pattern);
            popoverContent = (React.createElement(UTCDateTimePicker, { onChange: onPickerDateChange(pattern), value: newDate, precision: TimePrecision.SECOND, key: "DatePicker" }));
            break;
        case DATE_FORMATS.SEC_REL:
            classNames = Classes.INPUT;
            dateValue = getDateValue("__-__:__:__", true);
            pattern = "00-HH:mm:00";
            changeFunc = onRelativeDateChange;
            break;
        case DATE_FORMATS.STD_ABS:
            classNames = "epoch-absolute-div";
            dateValue = getDateValue("____/__/__-__:__:__.___", false);
            pattern = "yyyy/MM/dd-HH:mm:ss.SSS";
            newDate = getDateFromData(formData, pattern);
            popoverContent = (React.createElement(UTCDateTimePicker, { onChange: onPickerDateChange(pattern), value: newDate, precision: TimePrecision.MILLISECOND, key: "DatePicker" }));
            break;
        case DATE_FORMATS.STD_REL:
            classNames = Classes.INPUT;
            dateValue = getDateValue("__-__:__:__.___", true);
            pattern = "00-HH:mm:00.000";
            changeFunc = onRelativeDateChange;
            break;
    }
    field = (React.createElement(EpochTextInput, { pattern: pattern, classNames: classNames, dateValue: dateValue, popoverContent: popoverContent, isDisabled: isDisabled, isReadOnly: isReadOnly, onChange: changeFunc }));
    if (isHidden) {
        return null;
    }
    else {
        return (React.createElement("div", { className: "fw-flex-container fw-form-field", role: "epochText-container" },
            React.createElement("div", { key: "date", style: {
                    display: "inline-block",
                    verticalAlign: "middle",
                } }, field)));
    }
};
export default EpochText;
//# sourceMappingURL=EpochText.js.map